import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api, formatApiError } from "@/lib/api";
import { Brand, TopControls } from "@/components/Nav";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const { t, nav: _n } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", {
        email, origin: window.location.origin, lang: localStorage.getItem("rai_lang") || "it",
      });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1718030463382-896949a8d53a" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-primary/40 mix-blend-multiply" />
      </div>
      <div className="flex flex-col justify-center px-8 sm:px-16 py-12 relative">
        <div className="absolute top-6 right-6"><TopControls /></div>
        <div className="mb-10"><Brand onClick={() => navigate("/")} /></div>
        {sent ? (
          <div className="max-w-sm" data-testid="forgot-sent">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-5">
              <MailCheck className="w-6 h-6 text-primary" />
            </div>
            <h1 className="text-3xl font-bold mb-3">{t("forgotTitle")}</h1>
            <p className="text-muted-foreground mb-8">{t("resetSent")}</p>
            <Link data-testid="forgot-back-login" to="/login" className="inline-flex items-center gap-2 text-primary font-medium hover:underline">
              <ArrowLeft className="w-4 h-4" />{t("backToLogin")}
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold mb-2">{t("forgotTitle")}</h1>
            <p className="text-muted-foreground mb-8">{t("forgotSub")}</p>
            <form onSubmit={submit} className="space-y-5 max-w-sm">
              <div><Label>{t("email")}</Label>
                <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" /></div>
              {err && <p data-testid="forgot-error" className="text-sm text-destructive">{err}</p>}
              <Button data-testid="forgot-submit" type="submit" className="w-full" disabled={busy}>
                {busy ? t("loading") : t("sendResetLink")}
              </Button>
            </form>
            <Link data-testid="forgot-back-login" to="/login" className="inline-flex items-center gap-2 text-sm text-primary font-medium hover:underline mt-6">
              <ArrowLeft className="w-4 h-4" />{t("backToLogin")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
